import type { FaireProductEntity } from "../../entity_types/product";

export const p_d9yk2es9us: FaireProductEntity = {
  token: "p_d9yk2es9us",
  type: "product",
  name: "Photo Frame - Ivory/Black Resin Wood Etched Border, 4x6 in.",
  brandName: "Sagebrook Home",
  imageUrl:
    "https://cdn.faire.com/fastly/471894f9f746e359e5bdf6e0f908df1eb5f28b66431bfd7efd97936416f0a47a.jpeg",
  priceDollars: 12.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/fe626a5ce134edfc7954ae11deddd961f4aaa53f1d24b0439b79e9445923a636.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
